module.exports = __webpack_public_path__ + "static/media/1POLICY22.92d95ff0.jpg";